<ng-container *ngIf="!hide">
  <td class="text-center" [attr.colspan]="numColumns">{{message}}</td>
</ng-container>
